import { useEffect } from 'react';

import { useSafeState } from 'hooks';

export const useDelayUnmount = (isMounted, delayTime) => {
  const [showElement, setShowElement] = useSafeState(false);

  const mountedStyle = { animation: 'fade-in 100ms ease-in' };
  const unmountedStyle = { animation: 'fade-out 100ms ease-in' };

  useEffect(() => {
    let timeoutId;

    if (isMounted && !showElement) {
      setShowElement(true);
    } else if (!isMounted && showElement) {
      // Delay unmounting the element for a smoother animation
      timeoutId = setTimeout(() => setShowElement(false), delayTime);
    }

    return () => clearTimeout(timeoutId);
  }, [isMounted, delayTime, setShowElement]);

  return { showElement, mountedStyle, unmountedStyle };
};
